import InvestorCouponsError from './InvestorCouponsError';
class InvestorWithInsufficientFunds extends InvestorCouponsError {
    constructor(options) {
        super('The investor has not sufficient funds to buy', options);
    }
}
export default InvestorWithInsufficientFunds;
